import React, { FC, ReactNode } from 'react';

import './index.scss';

interface IModalProps {
  open: boolean;
  header?: ReactNode;
  body?: ReactNode;
  footer?: {
    left?: ReactNode;
    right?: ReactNode;
  };
  onClose: () => void;
  className?: string;
  closeByBackground?: boolean;
}

const Modal: FC<IModalProps> = ({
  open,
  onClose,
  header,
  body,
  footer,
  className,
  closeByBackground = true,
}) =>
  open ? (
    <div className={`modal ${className}`}>
      <div className="modal__background" onClick={closeByBackground ? onClose : undefined} />
      <div className="modal__container">
        <div>
          <div className="modal__header">
            <div className="modal__title">{header}</div>
            <div className="modal__close" onClick={onClose}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18 6L6 18"
                  stroke="#444444"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 6L18 18"
                  stroke="#444444"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
        {body && <div className="modal__body">{body}</div>}

        {footer && (
          <div className="modal__footer">
            <div className="modal__footer__left">{footer.left}</div>
            {footer.right && (
              <div className="modal__footer__right">{footer.right}</div>
            )}
          </div>
        )}
      </div>
    </div>
  ) : null;

export default Modal;
